import findIndex from 'lodash/findIndex';
import { getCookie, setCookie } from '../../utilities/cookie';
import { getFormattedPrice } from '../../utilities/vtex';
import api from '../../api/vtex';

/**
 * Format the items currency based on sales policy config.
 *
 * @private
 * @param {Array<Object>} items
 * @returns {Array<Object>}
 */
function getFormattedItems(state, items) {
  return items.map((item) => ({
    ...item,
    price: getFormattedPrice(state, item.price),
  }));
}

export default {
  namespaced: true,
  //
  // State
  state: {
    id: null,
    currency: '',
    locale: '',
    items: [],
    open: false,
  },
  //
  // Getters
  getters: {
    id({ id }) {
      return id;
    },
    ready({ id }) {
      return !!id;
    },
    culture({ locale, currency }) {
      return {
        locale,
        currency,
      };
    },
    items({ items }) {
      return items;
    },
    quantity({ items }) {
      return items.length;
    },
    open({ open }) {
      return open;
    },
  },
  //
  // Mutations
  mutations: {
    setCart(state, data) {
      state.id = data.id;
      state.currency = data.preferences.currency;
      state.locale = data.preferences.country;
      state.items = getFormattedItems(state, data.items);
    },
    toggle(state, open) {
      state.open = open;
    },
  },
  //
  // Actions
  actions: {
    initialize({ commit }, { origin }) {
      const uid = getCookie('vtex_cart_id');

      if (uid) {
        return api.getCartByID(origin, uid).then((data) => {
          commit('setCart', data);

          return data;
        });
      }

      return api.getCart(origin).then((data) => {
        setCookie('vtex_cart_id', data.id);

        commit('setCart', data);

        return data;
      });
    },
    add({ state, dispatch }, { origin, item }) {
      return api.addToCart(origin, state.id, item).then((data) => {
        dispatch('initialize', { origin });

        return data;
      });
    },
    remove({ state, dispatch }, { origin, item }) {
      return dispatch('initialize', { origin })
        .then((data) =>
          api.removeFromCart(origin, state.id, {
            id: item.id,
            index: findIndex(data.items, { sku: item.id }),
          }),
        )
        .finally(() => dispatch('initialize', { origin }));
    },
  },
};
